export default __webpack_public_path__ + "img/89ac9be7da909abda128a8b9bea53de1.svg";